import styled from "styled-components";
import { mediaMaxWidth } from "../../../utils/mediaQueriesTemplate";

export const Wrapper = styled.div`
  position: fixed;
  top: 210px;
  left: 60px;
  z-index: 5;
  width: calc(100vw - 60px);
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 300px);
  transition: height 0s, opacity 0.2s ease-in-out;

  ${mediaMaxWidth.tablet`
    top: 116px;
    left: 0;
    width: 100vw;
  `}
`;

export const Modal = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 220px;
  height: 200px;
  border-radius: 8px;
`;

export const Inner = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 135px;
  height: 95px;
`;

export const Spinner = styled.img`
  width: 40px;
  height: 40px;
  align-self: center;
`;
